/* eslint-disable */
;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);

	var jsNavCurrentOT;

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $('.header').outerHeight();

	var $animated = $('.animated');
	var winHeight = $win.height();
	var winWidth = $win.width();
	var winScroll = $win.scrollTop();

	function hasScrolled() {
		var st = $(this).scrollTop();

		if(Math.abs(lastScrollTop - st) <= delta) {
			return;
		}

		if (st > lastScrollTop && st > navbarHeight) {
			// Scroll Down
			$('.header').removeClass('down').addClass('up');
			$('.js-nav').removeClass('down').addClass('up');
		} else {
			// Scroll Up
			if(st + $(window).height() < $(document).height()) {
				$('.header').removeClass('up').addClass('down');
				$('.js-nav').removeClass('up').addClass('down');
			}
		}

		lastScrollTop = st;
	}

//Animate Sections
function animateElements() {
	winScroll = $win.scrollTop();

	if ( $animated.length === 0 ) {
		return;
	}
};

/**
 * Scroll to given element.
 *
 * @param  {object} $target jQuery Object
 * @return {void}
 */
function scrollToElement(id) {
	$('html, body').stop().animate({
		'scrollTop': $(id).offset().top - 100
	}, 900);
}

function animate(winST) {
	$('.animate').each(function(){
		var $this = $(this);

		if (winST + ($win.outerHeight() / 1.3) > $this.offset().top) {
			$this.addClass('animated');
		} else if (winST + ($win.outerHeight() / 2) < $this.offset().top) {
			$this.removeClass('animated');
		}
	});
}

//Default Map
function initMultipleMaps() {
	$('.map').each(function(){
		var locations = $(this).data('locations');
		var mapData = $(this).data('map');
		var bounds = new google.maps.LatLngBounds();

		if ( locations ) {
			var map = new google.maps.Map(this, {
				center: {lat: -34.397, lng: 150.644},
				styles: [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#c9c7c5"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#e8e6e3"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#d0cecb"}]}],
			});

			locations.forEach(function(elem) {
				new google.maps.Marker({
					map: map,
					position: elem,
				});

				bounds.extend(elem);
			});

			map.fitBounds(bounds);
		} else if ( mapData ) {
			var map = new google.maps.Map(this, {
				center: mapData.center,
				zoom: 18
			});

			new google.maps.Marker({
				map: map,
				position: mapData.center,
			});
		}
	});
}

$doc.ready(function() {
	//$('.features-primary').equalizer({
	//	columns : '.feature-primary'
	//});

	$doc.bind('gform_confirmation_loaded', function(event, formId) {
		$('.section .section__head--contact').hide();
	});

	$('.nav')
		.on('mouseenter', function() {
			if ( $win.width() > 767 ) {
				$('.header').addClass('hover-menu')
			}
		})
		.on('mouseleave', function() {
			if ( $win.width() > 767 ) {
				$('.header').removeClass('hover-menu')
			}
		})


	// Scroll to Element
	$('.btn-scroll').on('click', function(e){
		e.preventDefault();

		scrollToElement($(this).attr('href'));
	});

	//JS Dropdiown
	$('.js-dropdown li')
	.on('mouseenter', function() {
		$('.header').addClass('hover-dropdown')
	})
	.on('mouseleave', function() {
		$('.header').removeClass('hover-dropdown')
	})

	//JS Toggle
	$('.js-toggle').on('click', function(e) {
		e.preventDefault();

		var target = $(this).data('target')
		var activeClass = $(this).data('class')

		$( target )
		.toggleClass( activeClass )
	})

	//JS Popup
	$('.js-popup').magnificPopup({
		type: 'ajax',
		removalDelay: 300,
		mainClass: 'mfp-fade'
	});

	$('.feature-popup').on('click', function(e){
		e.preventDefault();
		var fragment = $(this).data('fragment');
		$.ajax({
			url: crb_options.admin_ajax_url,
			type: 'GET',
			data: {
				'action' : 'open_popup',
				'fragment' : fragment
			},
			success: function( result ) {

				$.magnificPopup.open({
					removalDelay: 300,
					mainClass: 'mfp-fade',
					items: [
						{
							type: 'inline',
							src: result
						}
					]
				})
			}
		})
	});


	// Toll Free Phone Select
	$doc.on('change', '.region-select', function(e){
		var index = $(this).val();

		$('.region-phone li')
			.eq(index)
			.addClass('active')
			.siblings()
			.removeClass('active');
	});

	//Tabs
	$('.tabs .tabs__nav a').on('click', function(event) {
		var $tabLink = $(this);
		var $targetTab = $($tabLink.attr('href'));

		$tabLink
		.parent()
		.add($targetTab)
		.addClass('active')
		.siblings()
		.removeClass('active');

		event.preventDefault();
	});

	//Mobile Nav
	$('.nav a').on('click', function(e){
		if ( $win.width() < 768 ) {
			var $parent = $(this).parent();
			var $siblingUl = $parent.find(' > .dropdown');

			if ( $siblingUl.length && !$parent.hasClass('open') ) {
				$parent.addClass('open').siblings().removeClass('open').find('.open').removeClass('open');

				$('.header').addClass('menu-expanded');

				e.preventDefault();
			}
		}
	});

    $('.js-dropdown-primary li').on('click', function() {
        var $this = $(this)

        if ( $win.width() < 767 ) {
            $this
				.addClass('open')
                .find('> .dropdown')
                .slideDown();

            $this
                .siblings()
				.removeClass('open')
                .find('.dropdown')
                .slideUp();

        }
    });

	$('.nav .dropdown a i').on('click', function(e){
		var $this = $(this)

		if ( $win.width() < 767 ) {
			if ( $this.closest('li').hasClass('open') ){

				$this
				.closest('li')
				.removeClass('open')
				.find('.dropdown')
				.slideUp();

				e.preventDefault();
				e.stopPropagation();
			}
		};
	});

	$('.nav-prev').on('click', function(e) {
		e.preventDefault();

		$('.header').removeClass('menu-expanded')
		$('.nav').find('.open').removeClass('open')
		$('.nav').find('.js-dropdown-primary .dropdown').slideUp()
	});

	$('.btn-burger').on('click', function(e) {
		e.preventDefault();

		$('.header .header__content .btn-burger').toggleClass('active')
		$('.header').toggleClass('active')
		$('body').toggleClass('active')
		$('.content').toggleClass('active')

		setTimeout(function() {
			$('.header').removeClass('menu-expanded')
			$('.nav').find('.open').removeClass('open')
			$('.nav').find('.js-dropdown-primary .dropdown').slideUp()
		}, 200);
	});
});

var $iconClone;

$win.on('load', function() {
    $('.logo-slider').slick({
        arrows: false,
        speed: 8000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true
    });

	$('.slider--main .slider__slide').outerHeight($win.outerHeight());

    $('.remove-event-link h6:first-child a').removeAttr("href");

	animateElements();

	var scrolledY = $win.scrollTop();
	animate(scrolledY);

	if ( $('.js-nav').length ) {
		jsNavCurrentOT = $('.js-nav').offset().top;
	}

	if ( $('.map').length ) {
		initMultipleMaps()
	}

	$('.slider--main .slider__slides')
	.addClass('owl-carousel')
	.owlCarousel({
		items: 1,
		smartSpeed: 500,
		loop: true,
		dots: true,
		autoplay: true,
		animateOut: 'fadeOut'
	});

    $('.slider--heroes').owlCarousel({
        smartSpeed: 500,
        loop: true,
        dots: true,
        nav: true,
        autoplay: false,
        animateOut: 'fadeOut',
        margin: 30,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 3
            }
        }
    });

    $('.iconbox-slider').owlCarousel({
        smartSpeed: 500,
        loop: true,
        dots: true,
        nav: true,
        autoplay: false,
        animateOut: 'fadeOut',
        margin: 30,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 3
            }
        }
    });

	$('.slider--primary .slider__slides')
	.addClass('owl-carousel')
	.owlCarousel({
		autoplay: true,
		items: 1,
		smartSpeed: 500,
		loop: true,
		dots: true,
		nav: true,
		navText: [
		'<i class="fa fa-angle-left"></i>',
		'<div class="slider-counter"><span class="slide-number">1</span> of <span class="slide-total"></span></div><i class="fa fa-angle-right"></i>'
		],
		onInitialized: function(data) {
			$slideNumber = $('.slider--primary').find('.slide-number');

			$('.slider--primary').find('.slide-total').text(data.item.count);
		},
		onTranslated: function(data) {
			$slideNumber.text(data.page.index + 1)
		}
	});

	$('.slider--single .slider__slides')
	.addClass('owl-carousel')
	.owlCarousel({
		autoplay: true,
		items: 1,
		smartSpeed: 500,
		loop: true,
		dots: false,
		nav: true,
		margin: 15
	});

	//TextBlind
	if ( $('.textblind').length ) {
		var words;

		$('.textblind').each(function () {
			var $this = $(this);
			var $icon = $this.find('i')

			if ($icon.length) {
				$iconClone = $icon.clone();

				$icon.remove();
			}

			var spanText = $(this).find('span').text();

			words = spanText.split(" ");
		});

		var smallInserted = $('.textblind').html().split(" ").join(" </small><small>");
		var wrapped = '<small>'.concat(smallInserted, '</small>');

		$('.textblind').html(wrapped);
		var refPos = $('.textblind small:first-child').position().top;
		var newPos;

		$('.textblind small').each(function (index) {
			newPos = $(this).position().top;

			if (index == 0) {
				return;
			}

			if (newPos == refPos) {
				$(this).prepend($(this).prev().text() + " ");
				$(this).prev().remove();
			}

			refPos = newPos;
		});

		$('.textblind').each(function () {
			var $el = $(this),
			$small = $el.children('small'),
			className = 'blind';

			$small.wrap('<small class=' + className + '></small>');

			if (words.length) {
				for (var i = 0; i < words.length; i++) {
					$(this).find('small:contains(' + words[i] + ')').each(function () {
						var newText = $(this).html().replace(words[i], '<span>' + words[i] + '</span>');
						$(this).html(newText);
					});
				}
			}
		});

		setTimeout(function () {
			if ($iconClone) {
				$('.textblind .blind:last-child :last-child').append($iconClone);
			}

			$('.textblind').addClass('start-animation');
		}, 900);
	}
})
.on('scroll', function() {
	var scrolledY = $win.scrollTop();

	//Fixed Header
	$('.header').toggleClass('fixed', $win.scrollTop() > 0)

	//Animate Sectioins
	animate(scrolledY);
})
.on('load scroll', function() {
	//JS Nav
	if ( $('.js-nav').length ) {
		var winST= $win.scrollTop();
		var $jsNav = $('.js-nav');

		if ( winST > $jsNav.offset().top ) {
			$('.wrapper').addClass('fixed-nav')
			return;
		} else if ( winST < jsNavCurrentOT - $('.header').outerHeight() ) {
			$('.wrapper').removeClass('fixed-nav')
			return
		}
	}
})
.on('load resize', function() {

	$('.full-height').each(function() {
		$(this).outerHeight($win.outerHeight())
	})

	// Hide Header on on scroll down
	$win.scroll(function(event){
		didScroll = true;
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	if ( $win.width() < 767 ) {
		$('.header__content').outerHeight($win.outerHeight())

		$('.js-nav-slider ul')
		.addClass('owl-carousel')
		.owlCarousel({
			items: 2,
			margin: 30,
			loop: false,
			autoWidth: true
		})


	} else {
		$('.js-nav-slider ul').trigger('destroy.owl.carousel');
		$('.js-nav-slider ul').removeClass('owl-carousel');

	}

})
.on('resize', function() {
	$('.textblind').addClass('resized');
})
})(jQuery, window, document);
